import React from "react";
import { useAuth } from "./AuthProvider";

const normalizePermissions = (permission) => {
  if (!permission) return [];
  return Array.isArray(permission) ? permission : [permission];
};

const hasAnyPermission = (userPermissions, requiredPermissions) => {

  if (!Array.isArray(userPermissions)) return false;

  const normalizedRequiredPermissions = normalizePermissions(requiredPermissions);

  // console.log("User Permissions:", userPermissions);
  // console.log("Required Permissions:", normalizedRequiredPermissions);

  const hasPermission = normalizedRequiredPermissions.some((perm) => userPermissions.includes(perm));

  // console.log("Has Permission:", hasPermission);
  return hasPermission;
};

export const ShowButton = ({ permission, children }) => {
  const { userPermissions = [] } = useAuth();
  const hasPermission = hasAnyPermission(userPermissions, permission);

  // console.log("Rendering ShowButton - Permission Granted:", hasPermission);

  return (
    <div
      style={{ pointerEvents: hasPermission ? "auto" : "none", opacity: hasPermission ? 1 : 0.5 }}
      tabIndex={hasPermission ? 0 : -1}
    >
      {children}
    </div>
  );
};

export const ShowComponent = ({ permission, children }) => {
  const { userPermissions = [] } = useAuth();
  const hasPermission = hasAnyPermission(userPermissions, permission);

  // console.log("Rendering ShowComponent - Permission Granted:", hasPermission);

  return hasPermission ? children : null;
};

export const hasPermission = (permissions, requiredPermissionKey) => {
  return hasAnyPermission(permissions, requiredPermissionKey);
};
